// A line item photo. Server photos arrive with a 240px thumbnail only. A photo
// taken on this device keeps its full-size data URL in base64 until mrf/photos
// has it (uploaded is false until then); after that it's thumbnail only, like
// the rest, and full size is fetched when it's viewed.
export class MrfPhoto {
  id = 0
  uuid = ''
  photo_type = 'image/jpeg'
  photo_data_tn = ''
  base64 = ''
  uploaded = true
  created_at = ''

  static buildOne(obj: any): MrfPhoto {
    const target: MrfPhoto = Object.assign(new MrfPhoto(), obj)
    // Postgres' base64 encoding wraps lines, which a data URL can't carry.
    if (target.photo_data_tn) target.photo_data_tn = String(target.photo_data_tn).replace(/\s/g, '')
    if (!target.photo_type) target.photo_type = 'image/jpeg'
    return target
  }

  static buildMany(objs: any[]): MrfPhoto[] {
    return Array.isArray(objs) ? objs.map(o => MrfPhoto.buildOne(o)) : []
  }

  static thumbUrl(photo: MrfPhoto | undefined | null): string {
    if (!photo) return ''
    if (photo.base64) return photo.base64
    if (photo.photo_data_tn) return 'data:' + (photo.photo_type || 'image/jpeg') + ';base64,' + photo.photo_data_tn
    return ''
  }
}
